wbApp.factory('pricingSvc', ['$resource', '$q', 'repositorySvc',
    function ($resource, $q, repositorySvc) {

        var Pricing = $resource('/restapi/pricing/:id', {}, {
            'calculateReservationPrice': { method: 'POST', url: '/restapi/pricing/calculate-reservation-price' }
        });

        var lastModel = null;
        var lastReturn = null;

        // {
        //     userId:,
        //     studentsIds: [],
        //     employeeId:,
        //     placeId:,
        //     reservationStartDate:,
        //     reservationEndDate
        // }
        function calculateReservationPrice(model, skipErrorHandler)
        {
            if (angular.equals(lastModel, model)) {
                return lastReturn;
            }

            lastReturn = Pricing['calculateReservationPrice'](
                model,
                function (success) {
                },
                function (error) {
                    if (!skipErrorHandler) {
                        repositorySvc.defaultErrorHandler(error);
                    }
                });

            lastModel = model;

            return lastReturn;
        }

        return {
            calculateReservationPrice: calculateReservationPrice
        }
    }]);
